import moment from 'moment'
import { useEffect, useState } from 'react'

import api from '../../../services/api'
import useModal from '../../../hooks/useModal'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import * as S from '../Modal.styles'

import { ReactComponent as CloseIcon } from '../../../assets/images/close_delete_icon.svg'
import { UpdateAttendanceBtn } from '../../Buttons'
import { DailyLogTable } from '../../Tables'

export default function GetDailyLogModal({ logOn, setDailyLogList, currentPage, limit }) {
  const { openModal, closeModal } = useModal()
  const [attendanceInfo, setAttendanceInfo] = useState({})
  const [dailyLogContentsList, setDailyLogContentsList] = useState([])
  const [_logOn, setLogOn] = useState(logOn)

  useEffect(() => {
    api.get(`/attendances/${_logOn}`)
      .then(result => setAttendanceInfo(result.data))
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })

    api.get(`daily-logs/${_logOn}`)
      .then(result => setDailyLogContentsList(result.data.dailyLogContentsList))
      .catch(e => {
        console.error(e)
        const props = {
          type: 'alert',
          props: {
            isError: true,
            contents: e.response?.data.message || e.message
          }
        }
        openModal(props)
      })
  }, [_logOn])

  return (
    <>
      <S.Background />
      <S.ModalBox max_height='600px' min_height='400px' width='600px'>
        <CloseIcon
          className='close-icon'
          width='25px'
          onClick={closeModal}
        />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            defaultValue={moment(_logOn)}
            format='YY-MM-DD'
            label='데일리 로그 날짜'
            maxDate={moment()}
            onChange={(v) => {
                setLogOn(moment(v).format('YYYY-MM-DD'))
              }
            }
            slotProps={{ textField: { size: 'small' }}}
            sx={{
              width: '25%',
              display: 'flex',
              justifyContent: 'flex-start'
            }}
          />
        </LocalizationProvider>
        {/*출석 인증*/}
        <UpdateAttendanceBtn
          attendanceInfo={attendanceInfo}
          setAttendanceInfo={setAttendanceInfo}
          setDailyLogContentsList={setDailyLogContentsList}
          setDailyLogList={setDailyLogList}
          currentPage={currentPage}
          limit={limit}
          proofOn={_logOn}
          height='200px'
          width='260px'
        />
        {/*오늘의 데일리(일일) 로그*/}
        <DailyLogTable
          dailyLogContentsList={dailyLogContentsList}
          setDailyLogContentsList={setDailyLogContentsList}
          setDailyLogList={setDailyLogList}
          currentPage={currentPage}
          limit={limit}
          logOn={_logOn}
        />
      </S.ModalBox>
    </>
  )
}